import axios from 'axios'
import {API_URL} from '../../constants'
import router from './../../router'
const SAVE_CHANGES = 'SAVE_CHANGES'
const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
const LOGOUT = 'LOGOUT'

const state = {
  isLoggedIn: !!localStorage.getItem('token'),
  token: localStorage.getItem('token'),
  user: JSON.parse(localStorage.getItem('user')),
  business: {
    working_hours: {
      'monday': {'from': '09:00', 'to': '18:00', 'closed': false},
      'tuesday': {'from': '09:00', 'to': '18:00', 'closed': false},
      'wednesday': {'from': '09:00', 'to': '18:00', 'closed': false},
      'thursday': {'from': '09:00', 'to': '18:00', 'closed': false},
      'friday': {'from': '09:00', 'to': '18:00', 'closed': false},
      'saturday': {'from': '09:00', 'to': '18:00', 'closed': false},
      'sunday': {'from': '09:00', 'to': '18:00', 'closed': false},
    }
  },
  newUser: {
    email: null,
    password: null,
  },
  errorName: '',
}

// getters
const getters = {
  isLoggedIn: state => {
    return state.isLoggedIn
  },
  getUser: state => {
    return state.user
  },
}

// actions
const actions = {
  save_changes ({ commit, dispatch }, credentials) {
    axios.post(
      `${API_URL}/api/v2/businesses/signup`,
      credentials
    ).then(response => {
      if (response.data.data.token) {
        commit(
          LOGIN_SUCCESS,
          { token: response.data.data.token, user: response.data.data.user }
        )
        router.push({ name: 'Dashboard' })
      }
    }).catch((error) => {
      alert(error.response.data.error)
    })
  },
  logout ({ commit }) {
    localStorage.removeItem('token')
    commit(LOGOUT)
    router.push({ name: 'Login' })
  },
  async getSettingsData ({ commit, rootState }) {
    if (!rootState.auth.user) {
      return
    }

    const response = await axios.get(`${API_URL}/api/v3/business/${rootState.auth.user.business.id}`)
    if (response.data.success) {
      const business = response.data.data.business
      if (!business.working_hours) {
        business.working_hours = {
          'monday': {'from': '09:00', 'to': '18:00', 'closed': false},
          'tuesday': {'from': '09:00', 'to': '18:00', 'closed': false},
          'wednesday': {'from': '09:00', 'to': '18:00', 'closed': false},
          'thursday': {'from': '09:00', 'to': '18:00', 'closed': false},
          'friday': {'from': '09:00', 'to': '18:00', 'closed': false},
          'saturday': {'from': '09:00', 'to': '18:00', 'closed': false},
          'sunday': {'from': '09:00', 'to': '18:00', 'closed': false},
        }
      }
      commit('setSettingsData', business)
    }
  },
  async saveAccountChanges ({ commit, state, rootState }) {
    const response = await axios.post(`${API_URL}/api/v3/business/settings/${rootState.auth.user.business.id}`,
      {
        email: state.newUser['email'],
        password: state.newUser['password'],
      })
    if (response.data.success) {
      state.business.email = state.newUser.email
      localStorage.setItem('user', JSON.stringify(state.business))
    }
    state.errorName = response.data.error.message
  },
  async updateBusinessLogo ({ commit, state }) {
    const response = await axios.post(`${API_URL}/api/v3/business/logo`)
    if (response.data.success) {
      commit('setSettingsData', response.data.data.business)
      state.newUser = response.data.data.user.email
    }
  },

  async saveBusiness ({ commit, state, dispatch, rootState }, file = null) {
    const respons = await axios.post(
      `${API_URL}/api/v3/business/${rootState.auth.user.business.id}`,
      state.business,
    )
    const business = respons.data.data
    commit('setSettingsData', business)
    if (file) {
      const form = new FormData()
      form.append('image', file)
      await axios.post(
        `${API_URL}/api/v3/business/logo`,
        form,
      )
    }
    const response = await axios.get(`${API_URL}/api/v3/business/${rootState.auth.user.business.id}`)
    if (response.data.success) {
      commit('setSettingsData', response.data.data.business)
    }
  }
}

// mutations
const mutations = {
  [SAVE_CHANGES] (state) {
    state.pending = true
  },
  [LOGIN_SUCCESS] (state, { token, user }) {
    state.isLoggedIn = true
    state.pending = false
    state.token = token
    state.user = user
    localStorage.setItem('token', token)
    localStorage.setItem('user', JSON.stringify(user))
  },
  [LOGOUT] (state) {
    state.isLoggedIn = false
    state.user = null
    localStorage.removeItem('token')
    state.token = null
    localStorage.removeItem('user')
  },
  [LOGOUT] (state) {
    state.showModal = !state.showModal
  },
  onAddressChange (state, {field, value}) {
    state.business[field] = value
  },
  onWorkingHoursChange (state, {weekDay, field, time}) {
    state.business.working_hours[weekDay][field] = time
  },
  setSettingsData (state, data) {
    state.business = data
  },
  accountChanges (state, {field, value}) {
    state.newUser[field] = value
  },
  onClosedChange (state, {weekDay, value}) {
    state.business.working_hours[weekDay]['closed'] = value
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/business.js